import { render } from "./PostalCodeInput.vue?vue&type=template&id=06451a16&ts=true"
import script from "./PostalCodeInput.vue?vue&type=script&lang=ts"
export * from "./PostalCodeInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__